export const state = {
  users: [],
  departments: [],
  loading: true,
  error: "",
  isError: false,
};

export default state;
